import styled from "styled-components";
import {Form} from "react-bootstrap";

export const StyledFormControl = styled(Form.Control)`
  &:focus {
    box-shadow: none;
  }
`